"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NumberUtil {
    static parseFloatWithPrecision(str, precision) {
        const parsedString = parseFloat(str);
        if (isNaN(parsedString)) {
            return parsedString;
        }
        return this.roundDecimals(parsedString, precision);
    }
    /**
     * Round a number down to a specified precision
     * @param {number} n Number to round down
     * @param {number} precision Number of decimals
     * @returns {number} Rounded number with precision decimals
     */
    static roundDecimals(n, precision) {
        const precisionConstant = 10 ** precision;
        return Math.round(n * precisionConstant) / precisionConstant;
    }
    /**
     * Get the number formatted as specified by <html lang>, otherwise in danish.
     * @param {number} value the number to convert
     * @returns {string} the number as a locale string
     */
    static getLocaleString(value) {
        if (!NumberUtil.toLocaleStringSupportsOptions()) {
            return NumberUtil.getIE9Format(value);
        }
        return value.toLocaleString(NumberUtil.LANG);
    }
    /**
     * Get the number as the locale string specified in <html lang>, otherwise in danish.
     * Optionally choose a maximum and/or minimum number of decimal digits
     * Defaults to 2
     * @param {number} value the number to convert
     * @param {number} minDigit minimum decimal digits allowed
     * @param {number} maxDigit maximum decimal digits allowed
     * @returns {string} returns the number as a locale string with the desired digits
     */
    static getLocaleStringWithDigits(value, minDigit = 0, maxDigit) {
        if (!NumberUtil.toLocaleStringSupportsOptions()) {
            return NumberUtil.getIE9Format(value, minDigit, maxDigit);
        }
        return value.toLocaleString(NumberUtil.LANG, {
            maximumFractionDigits: maxDigit,
            minimumFractionDigits: minDigit
        });
    }
    /**
     * Get the number as the currency specified in <html lang>, otherwise in danish.
     * @param {number} value the number to convert
     * @returns {string} the number as a locale currency
     */
    static getLocaleCurrecy(value) {
        return value.toLocaleString(NumberUtil.LANG, {
            currency: NumberUtil.CURRENCY_MAP[NumberUtil.LANG],
            style: NumberUtil.CURRENCY_STYLE
        });
    }
    /**
     * Get the number as the currency specified in <html lang>, otherwise in danish.
     * Optionally choose a maximum and/or minimum number of decimal digits
     * Defaults to 2
     * @param {number} value the number to convert
     * @param {number} minDigit minimum decimal digits allowed
     * @param {number} maxDigit maximum decimal digits allowed
     * @returns {string} returns the number as a locale currency with the desired digits
     */
    static getLocaleCurrencyWithDigits(value, minDigit = 2, maxDigit = 2) {
        return value.toLocaleString(NumberUtil.LANG, {
            currency: NumberUtil.CURRENCY_MAP[NumberUtil.LANG],
            maximumFractionDigits: maxDigit,
            minimumFractionDigits: minDigit,
            style: NumberUtil.CURRENCY_STYLE
        });
    }
    /**
     * Get format for older browsers,
     * @param {number} value the number to convert
     * @param {number} minDigit minimum decimal digits allowed
     * @param {number} maxDigit maximum decimal digits allowed
     * @returns {string}
     */
    static getIE9Format(value, minDigit = 2, maxDigit = 2) {
        const valueAsString = `${value}`;
        const [left, right] = valueAsString.split(".");
        return `${left} ${(right ? "." + right.slice(minDigit, maxDigit) : "")}`;
    }
    static toLocaleStringSupportsOptions() {
        return (typeof Intl === "object" && Intl && typeof Intl.NumberFormat === "function");
    }
}
/**
 * Default to the danish language if no lang attribute is set in <html lang>
 * @type {string | string}
 */
NumberUtil.LANG = document.documentElement.lang || "da-DK";
NumberUtil.CURRENCY_STYLE = "currency";
/**
 * Map to convert the lang to the currency amount, currently only danish is supported
 * the currency values are a ISO-4217 standard, to extend currency refer to
 * https://www.currency-iso.org/dam/downloads/lists/list_one.xml
 * @type string returns currency as string value
 */
NumberUtil.CURRENCY_MAP = {
    "da": "DKK",
    "da-DK": "DKK"
};
exports.default = NumberUtil;
//# sourceMappingURL=NumberUtil.js.map